import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@zillow/constellation';
import { PAGE_DATA_ERROR } from '../../constants/stringConstants';

class ErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error({ error, info });
    if (typeof window !== 'undefined') {
      window.DD_RUM?.addError(new Error(error), { isErrorBoundary: true, stack: info.componentStack });
    }
  }

  render() {
    if (this.state.hasError) {
      return <Alert appearance="warning">{PAGE_DATA_ERROR}</Alert>;
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
